$(document).ready(function () {
  let filterByFromQuery = $("body").attr("filter_by") || null;
  let startDateFromQuery = $("body").attr("start_date") || null;
  let endDateFromQuery = $("body").attr("end_date") || null;
  let customPeriodFromQuery = $("body").attr("custom_period") || null;
  let prevSelectedPeriodFromQuery =
    $("body").attr("prev_selected_period") || null;
  if (p === "statistic_order") {
    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );
    handleCustomerIdChange(getAmountOfOrderAndSale);
    handleCustomPeriodChange(getAmountOfOrderAndSale);
    handleTopProductGroupChange(getAmountOfOrderAndSale);
    handleSupplierIdChange(getAmountOfOrderAndSale);
    handleProductGroupChange(getAmountOfOrderAndSale);
    handleUserChange(getAmountOfOrderAndSale);
    handlePlatformChange(getAmountOfOrderAndSale);
    handlePeriodChange(getAmountOfOrderAndSale);
    handleDateAndTimeChange(getAmountOfOrderAndSale);
    handlePreviousButton(getAmountOfOrderAndSale);
    handleNextButton(getAmountOfOrderAndSale);
    handleCompareByChange(getAmountOfOrderAndSale);
    handleProductChange(getAmountOfOrderAndSale);
    handlePaymentChange(getAmountOfOrderAndSale);
    handleVatCodeChange(getAmountOfOrderAndSale);
    handleLocationChange(getAmountOfOrderAndSale);
    handleCustomDayChange(getAmountOfOrderAndSale);
    let total1 = 0;
    let exportDateData = [];
    let exportOrderData = [];
    let htmlData = [];

    $(document).on("click", "#download-statistic-excel", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getOrderHtmlData();
      $.ajax({
        url: "/api/v1/private/statistics/download-statistic-excel",
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_order_data: exportOrderData,
          start_date: startDate,
          end_date: endDate,
          export_type: "order",
          html_data: htmlData,
          total_order: total1,
        }),
        xhrFields: { responseType: "blob" }, // important for binary data
        success: function (data) {
          // Check if running in React Native WebView
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk ordre (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  }
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            // Standard browser download
            const blob = new Blob([data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk ordre (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert("Error generating Excel file");
        },
        complete: function () {
          disabledOnClick.prop("disabled", false);
          disabledOnClick.html("Last ned(excel)");
        },
      });
    });

    $(document).on("click", "#download-statistic-pdf", function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css("width", btnWidth + "px");
      disabledOnClick.prop("disabled", true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getOrderHtmlData();
      if (!chartComponent) {
        alert("Chart not ready");
        disabledOnClick.prop("disabled", false).html("Last ned(pdf)");
        return;
      }

      // Convert Highcharts SVG to PNG
      const svg = chartComponent.getSVG();
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL("image/png"); // base64 PNG

        // Prepare payload using your Excel-style fields + chart PNG
        const payload = {
          export_date_data: exportDateData,
          export_order_data: exportOrderData,
          export_type: "order",
          html_data: htmlData,
          total_order: total1,
          chart_png: pngData, // PNG included
        };

        // AJAX POST to generate PDF
        $.ajax({
          url: "/api/v1/private/statistics/download-statistic-pdf",
          method: "POST",
          contentType: "application/json",
          data: JSON.stringify(payload),
          xhrFields: { responseType: "blob" }, // receive PDF
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk ordre (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf'
                    }
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: "application/pdf" });
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk ordre (${startDate.split(" ")[0]} - ${endDate.split(" ")[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert("Error generating PDF");
          },
          complete: function () {
            disabledOnClick.prop("disabled", false);
            disabledOnClick.html("Last ned(pdf)");
          },
        });
      };

      // Encode SVG for PNG conversion
      img.src =
        "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
    });

    function getOrderHtmlData() {
      let htmlData = [];
      $(".mobile-view .list-group").each(function () {
        let $li = $(this).find("li");

        let table = $li.eq(0).text().replace("Bord :", "").trim();
        let ref = $li.eq(1).text().replace("Ref :", "").trim();
        let date = $li.eq(2).text().replace("Dato :", "").trim();
        let order = [];
        $li
          .eq(3)
          .find(".product-name p")
          .each(function () {
            let text = $(this).text().replace(/\s+/g, " ").trim();
            order.push(text);
          });
        let totalText = $li
          .eq(4)
          .text()
          .replace("Totalt:", "")
          .replace(/\s+/g, "")
          .replace("kr", "")
          .replace(",", ".");
        let total = parseFloat(totalText);

        htmlData.push({ table, ref, date, order, total });
      });
      return htmlData;
    }

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals
      total1 = seriesData1.reduce((sum, val) => sum + floor(val), 0);
      const total2 = seriesData2
        ? seriesData2.reduce((sum, val) => sum + floor(val), 0)
        : 0;

      chartComponent = Highcharts.chart("event-line-graph", {
        chart: {
          type: "column",
        },
        title: {
          text: null,
        },

        exporting: {
          enabled: false,
          buttons: {
            contextButton: {
              menuItems: [
                {
                  text: "Last ned PDF",
                  onclick: function () {
                    this.exportChart({ type: "application/pdf" });
                  },
                },
                {
                  text: "Last ned Excel",
                  onclick: function () {
                    const chart = this;

                    // Get the default table
                    const table = chart.getTable();

                    // Parse the existing table to extract data
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(table, "text/html");
                    const rows = doc.querySelectorAll("tr");

                    let csvContent = "";

                    // Add BOM for proper UTF-8 encoding in Excel
                    csvContent = "\uFEFF";

                    // Add custom header rows
                    csvContent += "Statistikk: Ordrebeløp \n";
                    csvContent += startDate + " - " + endDate + "\n";
                    csvContent +=
                      "Generert:," + new Date().toLocaleString("no-NO") + "\n";
                    csvContent += "\n"; // Empty row

                    // Add table header and data rows
                    rows.forEach((row, index) => {
                      const cells = row.querySelectorAll("th, td");
                      const rowData = [];

                      cells.forEach((cell) => {
                        let cellText = cell.textContent.trim();
                        // Fix the "Chart" header issue
                        if (cellText === "Chart" || cellText === "Category") {
                          cellText = "Dato";
                        }
                        rowData.push(cellText);
                      });

                      if (rowData.length > 0) {
                        csvContent += rowData.join(",") + "\n";
                      }
                    });

                    // Add custom footer rows
                    csvContent += "Totalt," + total1 + "\n";
                    csvContent += "\n";
                    csvContent += "Dato," + "Ordre" + "," + "Totalt" + "\n";
                    csvContent +=
                      '"12/09/2025 18:23:34",' +
                      '"2 x cake\n1 x cola\n1 x tea",' +
                      '"173 kr"' +
                      "\n";

                    if (seriesData2 && total2 > 0) {
                      csvContent +=
                        "Totalt forrige " +
                        getPeriodTranslation(compareBy ?? "", startDate) +
                        "," +
                        total2 +
                        "\n";
                    }

                    // Create and download the file with proper UTF-8 encoding
                    const blob = new Blob([csvContent], {
                      type: "text/csv;charset=utf-8;",
                    });
                    const link = document.createElement("a");
                    const url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute(
                      "download",
                      "Ordrebeløp_" +
                        startDate.replace(/[^a-zA-Z0-9]/g, "_") +
                        "_" +
                        endDate.replace(/[^a-zA-Z0-9]/g, "_") +
                        ".csv"
                    );
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  },
                },
              ],
            },
          },
        },

        plotOptions: {
          series: {
            lineWidth: 4,
          },
        },
        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === "day") {
                return Highcharts.dateFormat(
                  "%e/%b",
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === "week") {
                return "Uke " + this.value;
              } else if (customPeriod === "month") {
                return Highcharts.dateFormat(
                  "%B %Y",
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: "Ordrebeløp",
          },
        },
        series:
          !compareBy || compareBy == "0"
            ? [
                {
                  name: "Ordrebeløp",
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
              ]
            : [
                {
                  name: `Ordrebeløp ( ${total1} ) ${legendText}`,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
                {
                  name: `Ordrebeløp forrige ${getPeriodTranslation(
                    compareBy ?? "",
                    startDate
                  )} ( ${total2} ) ${previousLegendText}`,
                  data: seriesData2.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
              ],
        tooltip: {
          formatter: function () {
            var tooltipText;
            if (startDate.split(" ")[0] === endDate.split(" ")[0]) {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%H:%M, %b %e", this.x) +
                "</b><br/>" +
                "Handler : " +
                formatNumber(this.y);
            } else if (customPeriod === "week") {
              tooltipText =
                "<b>" +
                "Uke" +
                " " +
                this.x +
                "</b><br/>" +
                "Handler : " +
                formatNumber(this.y);
            } else if (customPeriod === "month") {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%B - %Y", this.x) +
                "</b><br/>" +
                "Handler : " +
                formatNumber(this.y);
            } else {
              tooltipText =
                "<b>" +
                Highcharts.dateFormat("%A, %b %e, %Y", this.x) +
                "</b><br/>" +
                "Handler : " +
                formatNumber(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $(".custom-date-picker");

      if (period === "custom") {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      let page = parseInt($(this).attr("href").substring(6));
      getAmountOfOrderAndSale(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        null,
        page,
        1,
      );
    });

    function getAmountOfOrderAndSale(
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = 'all',
      userId = null,
      platform = "all",
      customPeriod,
      topProductGroupUniqueId = 0,
      customerId = 0,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      selectedDay = null,
      page = 1,
      getHtml = 0,
    ) {
      $.ajax({
        type: "POST",
        url: "/ajax/statistic_order/search",
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          selectedDay,
          page,
          get_page_html: getHtml,
        },
      })
        .done(function (data) {
          if (!getHtml) {
            if (data.totalQuantity) {
              $("#key-figure-sale").text(data.totalQuantity);
              $("#key-figure-order").text(data.totalQuantity);
            } else {
              $("#key-figure-sale").text("0");
              $("#key-figure-order").text("0");
            }
            if (
              data.xAxisArray.length > 0 &&
              data.seriesData1 &&
              data.seriesData2
            ) {
              exportDateData = data.xAxisArray;
              exportOrderData = data.seriesData1;
              eventLineChart(data.xAxisArray, data.seriesData1, data.seriesData2);
            }
            let aTags = $(".statistic-tab-group a");
            aTags.each(function () {
              let oldHref = $(this).attr("href").split("?")[0];
              let newHref =
                oldHref +
                `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
              $(this).prop("href", newHref);
            });
          }

          if (
            data &&
            data.html !== undefined &&
            data.html !== null &&
            data.html !== ""
          ) {
            $("#order-list-view").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    function displayGraphDynamically(durationOfstartAndEndDate) {
      if (isMobile) {
        if (durationOfstartAndEndDate <= 7) {
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 8 &&
          durationOfstartAndEndDate < 49
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      } else if (isTablet) {
        if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      } else {
        if (durationOfstartAndEndDate <= 180) {
          //day
          customPeriod = "day";
          $("#custom-period option[value='day']").prop("disabled", false);
          $("#custom-period option[value='day']").prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").removeClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else if (
          durationOfstartAndEndDate >= 181 &&
          durationOfstartAndEndDate < 365
        ) {
          //week
          customPeriod = "week";
          $(`#custom-period option[value="week"]`).prop("selected", true);
          $("#custom-period option[value='week']").prop("disabled", false);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").removeClass(
            "disabledOption"
          );
        } else {
          //month
          customPeriod = "month";
          $(`#custom-period option[value="week"]`).prop("selected", false);
          $(`#custom-period option[value="month"]`).prop("selected", true);
          $("#custom-period option[value='time']").prop("disabled", true);
          $("#custom-period option[value='day']").prop("disabled", true);
          $("#custom-period option[value='week']").prop("disabled", true);
          $("#custom-period option[value='time']").addClass("disabledOption");
          $("#custom-period option[value='day']").addClass("disabledOption");
          $("#custom-period option[value='week']").addClass("disabledOption");
        }
      }
    }

    getAmountOfOrderAndSale(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod
    );
    toggleCustomDatePicker();
  }
});
